import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";

// Custom Box to center content
const Container = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-around",
  backgroundColor: "#f5f5f5",
  padding: "8px 15px",
  borderRadius: "8px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  width: "270px", // Compact width
  textAlign: "center",
  marginBottom: "10px",
});

// Styled title
const Title = styled(Typography)({
  fontSize: "14px",
  fontWeight: "600",
  color: "#D10101", // Custom color
  marginBottom: "4px",
  textTransform: "uppercase",
  letterSpacing: "1px",
  fontFamily: "Poppins, sans-serif",
});

// Styled number
const Number = styled(Typography)({
  fontSize: "32px",
  fontWeight: "bold",
  color: "#333",
});

const ERPDrillCompleted = ({ number = 0 }) => {
  return (
    <Container>
      <Title>ERP Drill Completed</Title>
      <Number>{number}</Number>
    </Container>
  );
};

export default ERPDrillCompleted;
